import { CountryCode, Domain } from '@/types/common/enums';

/**
 * Returns the selected domain value based on application configuration and active deployment (in case of internal).
 *
 * If the current domain is INTERNAL, it attempts to read the country code from localStorage.
 * Otherwise, it returns the configured domain value.
 *
 * @deprecated Use {@link getCurrentCountry} instead. This function has polluted its context and relies on ambiguity deceitfully.
 * Accessing the country should be handled explicitly via {@link getCurrentCountry} for clarity and safety; and
 * accessing the current domain should be handled via {@link getCurrentDomain} instead.
 * @see getCurrentCountry
 * @see getCurrentDomain
 */
export function getSelectedDomain() {
  return window.config.DOMAIN === Domain.INTERNAL
    ? localStorage.country?.toUpperCase()
    : window.config.DOMAIN;
}

/**
 * Returns the country code from the currently active application configuration.
 * This value is set after a successful user login. It matches the active domain when the application is running in external mode.
 *
 * Note: Supported domain countries: EE, FI, LT, LV.
 * @see countryUserGroups
 */
export function getCurrentCountry(): CountryCode {
  return localStorage.getItem('country') as CountryCode;
}

/**
 * Returns the selected domain value based on application configuration and active deployment (in case of internal).
 * This value is set on startup therefore is available always (regardless of user login).
 */
export function getCurrentDomain(): Domain {
  return window.config.DOMAIN;
}
